export function getTimeStampParts(time: number) {
    let t = time / 1_000;
    const h = Math.floor(t / 3_600)
        .toString()
        .padStart(2, "0");
    t %= 3600;
    const m = Math.floor(t / 60)
        .toString()
        .padStart(2, "0");
    const s = Math.floor(t % 60)
        .toString()
        .padStart(2, "0");
    return {h, m, s};
}